// extracted by css-extract-rspack-plugin
export default {"cls1":"AnalyticsV2NavBar-cls1_Ffn","cls2":"AnalyticsV2NavBar-cls2_73d AnalyticsV2NavBar-cls1_Ffn"};